
import { windVane } from "../../../utils/tmallGenius";
import { getQueryString } from "../../../utils/url";
import { addChannel, updateChannel, deleteChannel } from "../../../api";
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

export default {
components: { CellBox, Group, Cell, XInput },
data() {
return {
channelData: {
channelName: "",
channelCode: ""
},
customChannelId: null,
channelList: []
};
},
/*------------------------------------------- 开始运行 -------------------------------------------------------*/
created() {
const channelName = getQueryString("channelName");
const channelCode = getQueryString("channelCode");
if (channelCode && channelName) {
this.channelData = {
channelCode,
channelName
};
windVane.setNavTitle("编辑频道");
} else {
windVane.setNavTitle("添加自定义频道");
}
const deviceId = getQueryString("deviceId");
if (typeof deviceId != "undefined") {
this.customChannelId = getQueryString("customChannelId");
this.channelData = {
channelCode,
channelName
};
}
},
beforeRouteEnter(to, from, next) {
next();
},
methods: {
/*------------------------------------------- 自定义方法-------------------------------------------*/
gotoChannelSelect() {
this.$router.replace({
path: "/settings/channel/select",
query: { ...this.$route.query, channelCode: this.channelData.channelCode }
});
},
saveChannel() {
const params = {
token: sessionStorage.getItem("token"),
deviceId: this.$route.query.deviceId,
channelName: this.channelData.channelName,
channel: this.channelData.channelCode
};
if (this.validation()) {
return;
}
if (this.isUpdate()) {
params.customChannelId = this.$route.query.customChannelId;
updateChannel(params).then(res => {
const { data, status, message } = res;
if (status == 0) {
this.$router.go(-1);
} else {
this.toast_fail();
}
});
} else {
addChannel(params).then(res => {
const { data, status, message } = res;
if (status == 0) {
this.$router.go(-1);
} else {
this.toast_fail();
}
});
}
},
validation() {
if (!this.channelData.channelName) {
this.toast_fail("请选择频道名称!");
return true;
}
if (!this.channelData.channelCode) {
this.toast_fail("请填写频道号!");
return true;
}
const numReg = /^\d+$/;
if (!numReg.test(this.channelData.channelCode)) {
this.toast_fail("频道号只能是纯数字!");
return true;
}
return false;
},
deleteChannel() {
const params = {
token: sessionStorage.getItem("token"),
customChannelId: this.$route.query.customChannelId
};
deleteChannel(params).then(res => {
const { data, status, message } = res;
if (status == 0) {
this.$router.go(-1);
} else {
this.toast_fail();
}
});
},
isUpdate() {
const customChannelId = this.$route.query.customChannelId;
return typeof customChannelId != "undefined";
}
/*------------------------------------------- 绑定方法 -------------------------------------------------------*/
}
};



// WEBPACK FOOTER //
// ./src/pages/settings/channel/ChannelAdd.vue